import { useMediaQuery } from 'react-responsive';

export function IsDesktop() {
    const isDesktop = useMediaQuery({ minWidth: 992 })
    return isDesktop;
};

export function IsMobile() {
    const isMobile = useMediaQuery({ maxWidth: 991 })
    return isMobile;
};